import { Core } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization/localize";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import { AppDownload } from "@faire/retailer/components/MobileAppPromoBanner/AppDownload";
import { getTotalBrandCount } from "@faire/retailer/lib/getMarketingCount";

const AppDownloadCTABase = () => {
  const { isMobile } = useViewport();

  const message = (() => {
    return isMobile ? (
      <StrictLocalMsg
        defaultMessage="Over {numBrands} brands at your fingertips"
        description={{
          text: "User can shop using the Faire app on their phone which is usually at their fingertips",
        }}
        values={DEPRECATED_backwardsCompatibleValues({
          numBrands: getTotalBrandCount(),
        })}
      />
    ) : (
      <StrictLocalMsg
        defaultMessage="Shop on-the-go with the Faire app"
        description={{ text: "User can shop on-the-go by using the Faire app" }}
      />
    );
  })();

  return (
    <Container>
      {isMobile ? (
        <Typography variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Get the Faire wholesale app"
            description={{
              text: "Prompt for user to download the Faire app",
              img: "https://cdn.faire.com/fastly/602c38fdc19d623fb3431135ba8367a6f3ca0693871fc58945a4f1662c90a291.png",
            }}
          />
        </Typography>
      ) : null}
      <Typography
        variant={{
          mobileAndAbove: "paragraphSansRegular",
          tabletAndAbove: "pageHeaderSerifRegular",
        }}
      >
        {message}
      </Typography>
      <Spacer size="2x" />
      <AppDownload eventPrefix="/footer-mweb" noModal={isMobile} />
    </Container>
  );
};

export const AppDownloadCTA = observer(AppDownloadCTABase);

const Container = styled(Column).attrs({
  align: { mobileAndAbove: "normal", desktopAndAbove: "flex-start" },
})`
  ${responsiveMediaQueries.mobile} {
    background-color: ${Core.surface.muted};
    border-top: 1px solid ${Core.border.muted};
    padding: ${getSpacing("3x")};
    width: 100vw;
  }

  ${responsiveMediaQueries.tablet} {
    padding: ${getSpacing("4x", 96, "8x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    max-width: 429px;
    padding: ${getSpacing("3x", 96, "5x", 0)};
  }

  ${responsiveMediaQueries.xLargeAndAbove} {
    max-width: 600px;
  }
`;
